import EnteringHeader from './EnteringHeader';

export default EnteringHeader;
